export default __webpack_public_path__ + "static/media/explore-dott-img.87fc8617.svg";